let curriculum = {};
let audioMap = {};

export const setCurriculum = (gc) => { curriculum = gc; };
export const setAudioMap = (am) => { audioMap = am; };

export const getCurriculum = () => curriculum;
export const getAudioMap = () => audioMap;
